export default __webpack_public_path__ + "static/media/THSarabunNew-Italic.1fd664cb.ttf";